import React, { useEffect } from 'react';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { Link } from 'react-router-dom';

function Thankyou() {

  return (
    <div className="bg-black text-white font-outfit pt-20 pb-20 mt-40">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-yellow-400 rounded-full opacity-20"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `float 5s ease-in-out ${Math.random() * 5}s infinite`,
            }}></div>
        ))}
      </div>
      <div className='text-center'>
        <h1 className='w-fit m-auto mb-5 font-syne text-6xl font-bold'>Order Placed Successfully!</h1>
        <Link to="/" className="bg-white font-syne w-fit p-3 font-thin rounded-full outline-none flex items-center justify-between gap-2 hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] hover:text-white transition-all duration-300 m-auto">
          <span className="font-medium hover:text-white text-black flex items-center gap-2">Back To Home  <IoIosArrowRoundForward className="text-xl" /></span>
        </Link>
      </div>
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-4 bg-yellow-400 opacity-0"
            style={{
              left: `${Math.random() * 100}%`,
              animation: `confetti 5s linear ${Math.random() * 2}s infinite`,
              transform: `rotate(${Math.random() * 360}deg)`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default Thankyou;